import { axios } from "../../helper/axios";
import { NotificationConstant } from "./notificationConstant";

const notificationApi = {};

notificationApi.notifications = () => {
  return axios.get(NotificationConstant.NOTIFICATION_API);
};

export { notificationApi };
